import * as React from 'react';
import { useEffect } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import Top from "../Top";

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import { styled } from '@mui/material/styles';
import Divider from '@mui/material/Divider';
import { FormControlLabel, Modal, Radio, RadioGroup, Typography } from '@mui/material';
import { FormContainer, PasswordElement, PasswordRepeatElement, TextFieldElement } from "react-hook-form-mui";

import HomeIcon from '@mui/icons-material/Home';
import DaumPostcode from "react-daum-postcode";

const typeSaveBasicParam = {
  id: '', companyId: '', userName: '', birthDate: '', cusId: '', phone: '', address: '', buildingNum: ''
  , email: '', zipCode: '', beforePassword: '', afterPassword: '', afterPasswordCheck: ''
};

const OfficeJoinAddress = () => {

  const navigate = useNavigate();
  const [isOpen, setIsOpen] = React.useState(false);
  const location = useLocation();
  const userInfo = { ...location.state };
  const [saveBasicParam, setSaveBasicParam] = React.useState(typeSaveBasicParam);

  useEffect(() => {
    setSaveBasicParam(userInfo);
  }, []);

  // 회원 추가정보를 받기 위한 화면으로 이동
  async function handleSaveUser(data: any) {
      const updatedProfile = {
        ...saveBasicParam,
        zipcode: saveBasicParam.zipCode,
      };

      navigate('/Join/UserJoinPhysical', { state: updatedProfile });
  }

  const handlePopClose = () => {
    setIsOpen(false)
  }

  const handleComplete = (data: any) => {
    setSaveBasicParam((prev) => true ? { ...prev, address: data.address } : prev);
    setSaveBasicParam((prev) => true ? { ...prev, zipCode: data.zonecode } : prev);
    handlePopClose();
  };

  return (
    <Container sx={Logbg}>
      <Top title="회원 가입" />

      <Stack direction={'column'} sx={{ justifyContent: 'center', alignContent: 'center' }}>
        <FormContainer
          values={{
            id: saveBasicParam.id, userName: saveBasicParam.userName, birthDate: saveBasicParam.birthDate,
            companyId: saveBasicParam.companyId, email: saveBasicParam.email, address: saveBasicParam.address, buildingNum: saveBasicParam.buildingNum,
            afterPassword: saveBasicParam.afterPassword, phone: saveBasicParam.phone,
            afterPasswordCheck: saveBasicParam.afterPasswordCheck
          }}
          onSuccess={data => handleSaveUser(data)}
        >

          <Card sx={{ p: '0px 20px 30px 20px', bgcolor: '#fff' }}>
            <Divider sx={{ fontSize: 18, mb: 2, mt: 2.5, fontWeight: 700 }}>주소</Divider>

            <Box sx={{ display: 'flex', alignItems: 'flex-end', mb: 2, width: '100%' }}>
              <HomeIcon sx={profileIcon} />
              <TextFieldElement
                name="address"
                id="address" label="주소" variant="standard"
                fullWidth
                rules={{
                  required: '필수 입력입니다.',
                }}
                sx={loginField}
                inputProps={{ readOnly: true }}
              />
              <Button sx={{ fontSize: 14, minWidth: 70, border: '1px solid #ed6c02', borderRadius: 20, color: '#ed6c02', bgcolor: '#ed6c0214', fontWeight: 700, p: .5 }} onClick={() => setIsOpen(true)}>
                검색
              </Button>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'flex-end', mb: 2 }}>
              <HomeIcon sx={profileIcon} />
              <TextFieldElement
                name="buildingNum"
                id="buildingNum" label="상세주소" variant="standard"
                fullWidth
                rules={{
                  required: '필수 입력입니다.',
                }}
                onChange={(e: any) => {
                  setSaveBasicParam((prev) => true ? { ...prev, buildingNum: e.target.value } : prev)
                }}
                sx={loginField}
              />
            </Box>
          </Card>

          <Box sx={{ p: '10px 0px 30px 0px' }}>
            <Stack direction="row" justifyContent="center" alignItems="center" spacing={0} sx={{ mt: 3, bgcolor: '#ffb068', borderRadius: '20px' }}>
              {/* <CareButton variant="contained" sx={{ bgcolor: '#FFB068', color: '#fff' }} onClick={() => navigate('../Join/Join')} >
                취소
              </CareButton> */}

              <CareButton variant="contained" type={'submit'}>
                다음
              </CareButton>
            </Stack>
          </Box>
        </FormContainer>

      </Stack>

      <Modal open={isOpen} onClose={handlePopClose} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999 }}>
        <div>
          <DaumPostcode onComplete={handleComplete} />
        </div>
      </Modal>

    </Container>
  );
}

const profileIcon = {
  color: '#888', mr: 1, my: 0.5, fontSize: 20
}

const CareButton = styled(Button)({
  boxShadow: 'none',
  textTransform: 'none',
  fontSize: 16,
  fontWeight: 700,
  padding: '10px 30px',
  lineHeight: 1.5,
  backgroundColor: '#EF8322',
  borderColor: '#EF8322',
  borderRadius: '20px',
  width: '100%',
  '&:hover': {
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
    boxShadow: 'none',
  },
  '&:active': {
    boxShadow: 'none',
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
  },
  '&:focus': {
    boxShadow: 'none',
  },
});

const loginField = {
  '& input': {
    fontSize: 16
  },
  '& label': {
    color: '#888',
    fontSize: 16
  },
  '& label.Mui-focused': {
    color: '#ef8322',
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: '#ef8322',
  },
  '& .MuiInputBase-root:before': {
    borderBottomColor: '#bbb',
  }
};

const Logbg = {
  bgcolor: '#f6f6f6',
  height: '100%',
  minHeight: '100vh',
  pb: 4,
  minWidth: '320px',
  pt: 10,
}

export default OfficeJoinAddress;